// ──────────────────────────────────────────────
// INDI Platform — Frontend palette helpers
// (Project data itself lives server-side at GET /api/showcase — canonical
// source for both web and mobile clients.)
// ──────────────────────────────────────────────

// Single canonical color per revenue category (used by all breakdown bars
// across all projects and both the in-card and modal views).
export const REVENUE_COLORS = {
  'Theatrical': '#06B6D4',         // cyan
  'VOD': '#84CC16',                // lime
  'Streaming License': '#A855F7',  // purple
  'International': '#F59E0B',      // amber
  'Festival License': '#EC4899',   // pink
  'Educational': '#3B82F6',        // blue (distinct from theatrical cyan)
};

export function colorForRevenueCategory(label) {
  return REVENUE_COLORS[label] || '#94A3B8';
}

// Per-genre color palettes for SVG poster fallback
export const genrePalettes = {
  Drama: { from: '#1E293B', to: '#475569', accent: '#F59E0B', text: '#F8FAFC', muted: '#CBD5E1' },
  Thriller: { from: '#0F0F12', to: '#3F1212', accent: '#EF4444', text: '#F8FAFC', muted: '#CA8A8A' },
  'Sci-Fi': { from: '#1E1B4B', to: '#5B21B6', accent: '#22D3EE', text: '#F8FAFC', muted: '#C4B5FD' },
  Documentary: { from: '#1F2937', to: '#78350F', accent: '#FBBF24', text: '#FEF3C7', muted: '#D6D3D1' },
  Horror: { from: '#000000', to: '#450A0A', accent: '#DC2626', text: '#FAFAF9', muted: '#A8A29E' },
  Comedy: { from: '#7C2D12', to: '#EA580C', accent: '#FCD34D', text: '#FFF7ED', muted: '#FED7AA' },
  Anthology: { from: '#312E81', to: '#831843', accent: '#F472B6', text: '#FDF2F8', muted: '#FBCFE8' },
  'Drama / Satire': { from: '#1E293B', to: '#3730A3', accent: '#EC4899', text: '#F8FAFC', muted: '#C7D2FE' },
  'Crime Drama': { from: '#0C0A09', to: '#3F2D1A', accent: '#FBBF24', text: '#FAFAF9', muted: '#D6D3D1' },
  'Music Documentary': { from: '#581C87', to: '#BE185D', accent: '#FBBF24', text: '#FDF2F8', muted: '#F5D0FE' },
  'Sci-Fi / Thriller': { from: '#0F0F23', to: '#312E81', accent: '#06B6D4', text: '#F8FAFC', muted: '#A5B4FC' },
  'Comedy / Drama': { from: '#7C2D12', to: '#9F1239', accent: '#FCD34D', text: '#FFF7ED', muted: '#FED7AA' },
  'Road Movie / Drama': { from: '#1F2937', to: '#7C2D12', accent: '#F59E0B', text: '#F8FAFC', muted: '#FDE68A' },
};

export function paletteFor(genre) {
  return genrePalettes[genre] || genrePalettes.Drama;
}
